import { ReactNode } from 'react';

import { cn } from '@/lib/css-utils';
import { Heading } from '@/ui-lib/heading';
import { Paragraph } from '@/ui-lib/paragraph';

export const RequestQuotePageWrapper = ({
    children,

    isModal = false,
    fullPage = false,
    subtitle,
}: {
    children: React.ReactNode;

    subtitle?: string | ReactNode | true; // true will be a "skeleton"

    isModal?: boolean;
    fullPage?: boolean;
}) => {
    return (
        <div
            className={cn('text-white', {
                'bg-frGrey-990': !isModal,
                'bg-black px-4 pb-2': isModal,
                'w-full -my-6 p-6 min-h-[calc(100vh-81px)]': fullPage,
                'rounded-lg overflow-y-auto max-h-modalH': !fullPage,
            })}
        >
            <div className="py-4">
                <div className="flex flex-col gap-2 mb-10">
                    <Heading>Request a firm quote</Heading>
                    <Paragraph>
                        {subtitle === true ? (
                            <span className="text-transparent inline-block select-none bg-frGrey-400 opacity-25 rounded-lg animate-pulse">
                                After you send the request, you will be contacted via your email (aPlaceHolderEmail) as
                                soon as possible.
                            </span>
                        ) : (
                            subtitle
                        )}
                    </Paragraph>
                </div>

                {children}
            </div>
        </div>
    );
};

export const MobilePlanSkeleton = ({ margin = true }: { margin?: boolean }) => (
    <div
        className={cn('w-full h-[140px] animate-pulse rounded-lg bg-frGrey-400 opacity-25', {
            'mt-17': margin,
        })}
    />
);

export const DesktopPlanSkeleton = ({ margin = true }: { margin?: boolean }) => (
    <div
        className={cn('w-full h-[450px] animate-pulse rounded-lg bg-frGrey-400 opacity-25', {
            'mt-17': margin,
        })}
    >
        <div className="bg-frGrey-300 w-full h-[70px] rounded-t-lg rounded-b-0"></div>
    </div>
);

export const RequestQuotePageLoader = () => (
    <>
        <div className="lg:hidden">
            <MobilePlanSkeleton />
        </div>

        <div className="max-lg:hidden">
            <DesktopPlanSkeleton />
        </div>

        <div className="animate-pulse opacity-25 mt-14">
            <div className="bg-frGrey-400 rounded w-1/3 max-w-64 h-5 " />
            <div className="bg-frGrey-400 rounded w-full mt-2 h-8" />

            <div className="bg-frGrey-400 rounded w-1/3 max-w-64 mt-4 h-5" />
            <div className="bg-frGrey-400 rounded w-full mt-2 h-[146px]" />
        </div>

        <div className="animate-pulse mt-10 flex justify-end opacity-25">
            <div className="bg-frGrey-400 rounded select-none text-transparent max-w-64 h-5">
                [ ] I agree to the terms and conditions
            </div>
        </div>

        <div className="animate-pulse mt-10 flex justify-end opacity-25">
            <div className="bg-frGrey-400 rounded select-none text-transparent w-36 h-10">Request a firm quote</div>
        </div>
    </>
);
